// extracted by mini-css-extract-plugin
export default {"wrapper":"UpgradeProducts_wrapper__Uvtn9"};